import { render, staticRenderFns } from "./SentenceForm.vue?vue&type=template&id=52861020&scoped=true"
import script from "./SentenceForm.vue?vue&type=script&lang=js"
export * from "./SentenceForm.vue?vue&type=script&lang=js"
import style0 from "./SentenceForm.vue?vue&type=style&index=0&id=52861020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52861020",
  null
  
)

export default component.exports